"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const recharts_1 = require("recharts");
function BarChart({ data, bars, width, height, title, description, XdataKey, YdataKey }) {
    const [descVisible, setDescVisible] = react_1.useState(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "max-width: max-content max-height: max-content relative inline-block m-2 pt-5 w-auto h-auto bg-white" },
            react_1.default.createElement("p", { className: "inline ml-4 text-black-900 text-lg font-normal leading-relaxed" }, title),
            react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: "inline w-5 h-5 text-black-800 cursor-pointer transform hover:scale-110 transition duration-500 ease-out", onMouseOver: () => {
                    setDescVisible(true);
                }, onMouseOut: () => {
                    setDescVisible(false);
                }, fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" })),
            descVisible && (react_1.default.createElement("div", { className: "max-height: max-content absolute inline p-2 max-w-xs bg-black-100 rounded" },
                react_1.default.createElement("div", { className: "text-black-400" }, description))),
            react_1.default.createElement(recharts_1.BarChart, { width: width, height: height, data: data, margin: {
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }, className: "mt-2 bg-white" },
                react_1.default.createElement(recharts_1.CartesianGrid, { strokeDasharray: "2 2" }),
                react_1.default.createElement(recharts_1.XAxis, { dataKey: XdataKey }),
                react_1.default.createElement(recharts_1.YAxis, { dataKey: YdataKey }),
                react_1.default.createElement(recharts_1.Legend, { align: "left", verticalAlign: "top", iconType: "rect", height: 45 }),
                react_1.default.createElement(recharts_1.Tooltip, null),
                bars.map((bar) => (react_1.default.createElement(recharts_1.Bar, { key: bar.dataKey, dataKey: bar.dataKey, stackId: bar.stackId, fill: bar.color })))))));
}
exports.default = BarChart;
